import * as _ from 'lodash'
import jobCostScheduleItemFactory from 'Scripts/models/jobCostScheduleItemModel';
import componentServices from 'Scripts/componentServices';
import JobCostEditReview from 'Scripts/components/jobCostEditReview';

export default class JobCostEditReviewAffinity extends JobCostEditReview {
	constructor (props) {
		super(props);
	}

	_getOptions () {
		return {
			approvePrompt: 'Is everything complete, correct, and approved by the processor?',
			exposeRejectionNote: false,
			rejectButtonLabel: 'Audit'
		};
	}

	rejectAction () {
		const saveState = componentServices.store.getIn(['viewState', 'globalSave', 'state']);
		const { jobCost, summary } = this.props;
		const reviewTarget = jobCost.currentChangeOrder || jobCost;
		const { approved } = this.state;
		const options = { autoSave: true };

		if (saveState !== 0 || approved !== '0' || reviewTarget.currentStatus !== 'pending-approval') { return; }

		this.props.updateModel(jc => {
			const contract = jc.proxiedContract || jc;
			const updateTarget = jc.currentChangeOrder || contract;
			const changeOrderKey = jc.currentChangeOrder && jc.currentChangeOrder.key;

			updateTarget.statusLog.add({ status: 'unlocked', description: 'audit-requested' });

			summary.eraseCalculatedItems(contract, changeOrderKey);
			summary.eraseStats(contract, changeOrderKey);

			if (updateTarget.getModelName() === 'JobCost') {
				contract.paymentTerms = [];

				const scheduleItem = _.find(contract.scheduleItems, { type: jobCostScheduleItemFactory.TYPES.PROPOSED_DELIVERY });
				if (scheduleItem) { contract.scheduleItems.delete(scheduleItem.key); }
			}
			else {
				// clear the payment terms for just this change order
				_.forEach(jc.paymentTerms, ti => jc.paymentTerms.delete(ti.key));
			}
		}, options);
	}
}
